import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { CaretDown, CaretUp, Faders, MagnifyingGlass, X } from '@phosphor-icons/react'
import MuiFilterSelect from './MuiFilterSelect'
import { buildSelectValue } from './filterSelectState'

const DROPDOWN_WIDTH_BY_FILTER = {
  role_ids: {
    min: 280,
    max: 460,
    searchable: true
  },
  status: {
    min: 220,
    max: 260,
    searchable: false
  }
}

function getDropdownConfig(filter) {
  const config = DROPDOWN_WIDTH_BY_FILTER[filter.key] || {
    min: 240,
    max: 340,
    searchable: true
  }
  const longestLabelLength = Math.max(
    filter.title?.length || 0,
    ...filter.options.map((option) => String(option.label || '').length),
    'Seleccionar todos'.length
  )
  const estimatedWidth = longestLabelLength * 8 + 96

  return {
    searchable: config.searchable,
    width: Math.min(config.max, Math.max(config.min, estimatedWidth))
  }
}

function FilterToolbarSearchInput({
  value,
  onChange,
  onEnter,
  onClear,
  placeholder,
  disabled = false
}) {
  return (
    <div className="search-input-containter mui-filter-toolbar__search-control">
      <MagnifyingGlass className="search-icon" size={15} weight="regular" aria-hidden="true" />

      <input
        value={value}
        onChange={onChange}
        onKeyDown={onEnter}
        className="round-search-input"
        placeholder={placeholder}
        disabled={disabled}
      />

      {value && !disabled ? (
        <button
          type="button"
          className="round-search-input-x"
          onClick={onClear}
          aria-label="Limpiar busqueda"
        >
          <X size={14} weight="bold" />
        </button>
      ) : null}
    </div>
  )
}

export default function MuiFilterToolbar({
  title = 'Filtrar por:',
  searchPlaceholder = 'Buscar',
  filterConfigs,
  appliedFilterSelections,
  isAnyFilterSelected,
  searchInput,
  disabled = false,
  onFilterChange,
  onResetFilters,
  onSearchChange,
  onSearchEnter,
  onSearchClear
}) {
  return (
    <>
      <h4 className="text-sub-title-filters">{title}</h4>

      <Box className="mui-filter-toolbar">
        <Box className="mui-filter-toolbar__bar">
          <Box className="mui-filter-toolbar__group">
            <span className="mui-filter-toolbar__icon-box" aria-hidden="true">
              <Faders className="mui-filter-toolbar__icon" size={18} weight="regular" />
            </span>

            <Box className="mui-filter-toolbar__chips">
              {filterConfigs.map((filter) => {
                const dropdownConfig = getDropdownConfig(filter)

                return (
                  <Box
                    key={filter.key}
                    className={`mui-filter-toolbar__item mui-filter-toolbar__item--${filter.key}`}
                  >
                    <MuiFilterSelect
                      title={filter.title}
                      options={filter.options}
                      value={appliedFilterSelections[filter.key] || buildSelectValue()}
                      onChange={(nextValue) => onFilterChange(filter.key, nextValue)}
                      disabled={disabled}
                      width="100%"
                      dropdownWidth={dropdownConfig.width}
                      maxVisibleOptions={filter.maxVisibleOptions || 5}
                      searchable={dropdownConfig.searchable}
                      searchIconNode={<MagnifyingGlass size={18} weight="regular" />}
                      clearIconNode={<X size={16} weight="regular" />}
                      openIconNode={<CaretUp size={18} weight="regular" />}
                      closedIconNode={<CaretDown size={18} weight="regular" />}
                    />
                  </Box>
                )
              })}
            </Box>
          </Box>

          <Box className="mui-filter-toolbar__search">
            <FilterToolbarSearchInput
              value={searchInput}
              onChange={onSearchChange}
              onEnter={onSearchEnter}
              onClear={onSearchClear}
              placeholder={searchPlaceholder}
              disabled={disabled}
            />
          </Box>
        </Box>

        {isAnyFilterSelected && !disabled ? (
          <Box className="mui-filter-toolbar__active">
            <Typography
              variant="body2"
              className="reset-filter-mui mui-filter-toolbar__reset"
              onClick={onResetFilters}
            >
              Restablecer filtros
            </Typography>
          </Box>
        ) : null}
      </Box>
    </>
  )
}
